<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="角色名称："  label-for="key">
              <Input search enter-button placeholder="请输入角色名称" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加角色</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.role_id)">编辑</a>
          <Divider type="vertical" v-if="row.role_id!==1"/>
          <a @click="del(row,'删除')" v-if="row.role_id!==1">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!-- 添加编辑-->
    <roleEdit :editShow="editShow" :id="role_id" @updateStatusModel="updateStatusModel"></roleEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="角色" :id="role_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { adminRoleList, delRole } from '@/api/adminRole'
import roleEdit from './components/roleEdit'
import modalSure from '@/components/modalSure'
export default {
  name: 'roleList',
  components: { roleEdit, modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: ''
      },
      editShow: false,
      modelApi: delRole,
      confirm: false,
      dataCount: 0,
      userInfo: [],
      loading: false,
      role_id: 0,
      columns2: [
        {
          title: '角色名称',
          key: 'role_name',
          minWidth: 120
        },
        {
          title: '权限',
          key: 'roles',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.roleList()
  },
  methods: {
    roleList () {
      this.loading = true
      adminRoleList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.roleList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.roleList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {
      this.role_id = id
      this.editShow = true
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    // 添加
    add () {
      this.editShow = true
    },
    del (row) {
      this.role_id = row.role_id
      this.$refs.modalSure.isShow = true
    },
    closeModal () {
      this.reload()
    }
  }
}
</script>
